// @ts-nocheck
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import { set, debounce } from 'lodash'
import { CardTitle } from 'material-ui/Card'
import { setSnackbarMessage } from '../../../actions/snackbar'
import DeleteIcon from 'material-ui/svg-icons/action/delete'
import Actions from './actions'

import {
  Dialog,
  FlatButton,
  RaisedButton,
  CircularProgress
} from 'material-ui'

import api from '../../../api'
import FieldList from '../../fieldList'

const loadingIndicatorTimeout = 100

class Edit extends Component<any, any> {
  componentWillMount () {
    this.getResource()
  }

  constructor (props) {
    super(props)
    this.state = {
      resource: {},
      errors: {},
      autocompleteText: {},
      autocompleteResults: {},
      showDelete: false,
      showUndelete: false,
      resourceFiles: {},
      submitting: false
    }
// @ts-ignore
    this.debouncedAutocompleteUpdate = debounce(this.performAutocompleteUpdate.bind(this), 500)
  }

  getResource () {
    const options = {
      ...this.props.options
    }

    const path = this.props.apiPath + '?with_deleted=true'

    return api
      .get(path, options)
      .then(res => {
        if (res.status === 200) {
          res.json().then(resource => {
            this.setState({ resource })
            this.getAutocompleteText(resource)
          })
        } else {
          this.props.onSnackbarMessage('Not found')
          browserHistory.push(this.props.successRedirectPath)
        }
      })
  }

  componentWillReceiveProps (nextProps) {
    // We are refreshing the component data by fetching the record again. This is currently only being used when
    // renewing an institutional membership in EditInstitutionMembership
    if (nextProps.lastUpdatedAt && this.props.lastUpdatedAt && nextProps.lastUpdatedAt > this.props.lastUpdatedAt) {
      this.getResource()
    }
  }

  getAutocompleteText (resource) {
    this.props.fields.forEach(field => {
      if (field.type !== 'autocomplete' || !resource[field.prop]) {
        return
      }

      let filterQuery

      if (field.referenceValue) {
        filterQuery = {
          [`filters[${field.referenceValue}]`]: resource[field.prop]
        }
      } else {
        filterQuery = {
          'filters[ids]': [resource[field.prop]]
        }
      }
      if (field.customFilters) {
        Object.keys(field.customFilters).map(filterKey => {
          filterQuery[`filters[${filterKey}]`] = field.customFilters[filterKey]
        })
      }
      api
        .get(field.references, {
          body: filterQuery
        })
        .then(res => res.json())
        .then(collection => {
          if (!collection[0]) {
            return
          }

          collection = field.dataHydrator ? field.dataHydrator(collection) : collection
          const text = collection[0][field.referenceProp] || collection[0][field.displayProp]

          this.setState({
            autocompleteText: Object.assign(this.state.autocompleteText, {
              [field.references]: Object.assign({ }, this.state.autocompleteText[field.references], {
                [field.prop]: text
              })
            })
          })
        })
    })
  }

  handleValueChange (field, e, value, index = null) {
    const newValue = field.filter ? field.filter(value, this.state.resource) : value

    this.setState({
      resource: Object.assign(this.state.resource, {
        [field.prop]: newValue
      })
    })
  }

  handleFileChange (field, e) {
    const formData = new window.FormData()
    const file = e.target.files[0]
    formData.append(field.prop, file, file.name)

    this.setState({
      resourceFiles: { ...this.state.resourceFiles, [field.prop]: { formData, file } }
    })
  }

  handleAutocompleteUpdateInput (field, searchText) {
    const { resource } = this.state

    // Any change to search text means the original selection is irrelevant.
    if (resource[field.prop]) {
      this.setState(state => ({
        resource: { ...state.resource, [field.prop]: null }
      }))
    }

    // Any change to search text means errors for this field are irrelevant.
    if (this.state.errors[field.prop]) {
      this.setState(state => ({
        errors: { ...state.errors, [field.prop]: [] }
      }))
    }

    // Need to update autocomplete search text in our state on every change so
    // that when we want to clear the field we are passing the Autocomplete a
    // different `searchText` prop.
    const autocompletePath = [field.references, field.prop]
    this.setState(state => ({
      ...state,
      autocompleteText: set(
        state.autocompleteText,
        autocompletePath,
        searchText
      )
    }))

    // Debounce the API call
// @ts-ignore
    this.debouncedAutocompleteUpdate(field, searchText)
  }

  performAutocompleteUpdate (field, searchText) {
    const { resource } = this.state
    const apiQuery = {
      filters: {
        [`${field.referenceProp}_ilike`]: searchText
      },
      limit: 100,
      order: [{ column: 'id', direction: 'asc' }]
    }

    const { query = {} } = field

    if (query.filters) {
      const filters = typeof query.filters === 'function'
        ? query.filters(resource)
        : query.filters

      apiQuery.filters = Object.assign({ }, apiQuery.filters, filters)
    }

    if (query.order) {
      apiQuery.order = query.order
    }
    if (field.customFilters) {
      Object.keys(field.customFilters).map(filterKey => {
        apiQuery[`filters[${filterKey}]`] = field.customFilters[filterKey]
      })
    }
    api
      .get(field.references, { body: apiQuery })
      .then(res => res.json())
      .then(collection => {
        if (field.referenceFilter) {
          collection = collection.filter(field.referenceFilter)
        }

        this.setState({
          autocompleteResults: Object.assign({}, this.state.autocompleteResults, {
            [field.references]: Object.assign({ }, this.state.autocompleteResults[field.references], {
              [field.prop]: field.dataHydrator ? field.dataHydrator(collection) : collection
            })
          })
        })
      })
  }

  handleAutocompleteSelection (field, chosenRequest, selectedIndex) {
    if (selectedIndex === -1) {
      // enter pressed in the autocomplete field
      if (field.rejectCustomValues) {
        this.setState(state => ({
          errors: { ...state.errors, [field.prop]: ['Must choose a valid option'] }
        }))
      }
      return
    }

    this.setState({
      resource: Object.assign({}, this.state.resource, {
        [field.prop]: chosenRequest[field.referenceValue || 'id']
      }),
      autocompleteText: set(
        this.state.autocompleteText,
        [field.references, field.prop],
        chosenRequest[field.displayProp]
      )
    })
  }

  handleChipInputAdd (field, chip) {
    this.setState({
      resource: Object.assign({}, this.state.resource, {
        [field.prop]: [...this.state.resource[field.prop], chip]
      })
    })
  }

  handleChipInputDelete (field, chip) {
    const index = this.state.resource[field.prop].indexOf(chip)

    if (index === -1) {
      return
    }

    this.setState({
      resource: Object.assign({}, this.state.resource, {
        [field.prop]: [
          ...this.state.resource[field.prop].slice(0, index),
          ...this.state.resource[field.prop].slice(index + 1)
        ]
      })
    })
  }

  startSubmit () {
// @ts-ignore
    this.timeout = setTimeout(() => {
      this.setState({ submitting: true })
    }, loadingIndicatorTimeout)
  }

  stopSubmit () {
    this.setState({ submitting: false })
// @ts-ignore
    if (this.timeout) {
// @ts-ignore
      clearTimeout(this.timeout)
    }
  }

  handleSubmit (e) {
    e && e.preventDefault()

    const path = this.props.apiPath + '?with_deleted=true'

    this.startSubmit()

    const resource = this.props.serializePatchBody
      ? this.props.serializePatchBody(this.state.resource)
      : this.state.resource

    api
      .patch(path, { body: resource })
      .then(res => {
        res.json().then(data => {
          if (!res.ok) {
            this.setState({
              errors: data.errors || {},
              message: data.message
            })
            this.stopSubmit()
            return
          }

          this.setState({
            errors: {}
          })

          this.uploadFiles(data).then(() => {
            const snackbar = this.props.onSnackbarMessage
            snackbar && snackbar(`Successfully updated #${data.id}`)
            this.stopSubmit()
            browserHistory.push(this.props.successRedirectPath)
          })
        })
      })
  }

  uploadFiles (data) {
    const fields = Object.keys(this.state.resourceFiles)
    if (fields.length) {
      return Promise.all(fields.map(field => {
        const path = `${this.props.apiPath}/${field}`
        const body = this.state.resourceFiles[field].formData
        return api.patchFile(path, { body })
      }))
    } else {
      return Promise.resolve()
    }
  }

  handleCancel () {
    browserHistory.push(this.props.successRedirectPath)
  }

  handleUndeleteOpen () {
    this.setState({
      showUndelete: true
    })
  }

  handleUndeleteClose () {
    this.setState({
      showUndelete: false
    })
  }

  handleUndeleteConfirm (e) {
    api
      .post(`${this.props.apiPath}/restore`)
      .then(res => {
        this.stopSubmit()
        if (res.status === 200) {
          this.props.onSnackbarMessage(`Successfully restored #${this.state.resource.id}`)
          browserHistory.push(this.props.successRedirectPath)
        }
      })
  }

  handleDeleteOpen () {
    this.setState({
      showDelete: true
    })
  }

  handleDeleteClose () {
    this.setState({
      showDelete: false
    })
  }

  handleDeleteConfirm (e) {
    api
      .del(this.props.apiPath)
      .then(res => {
        if (res.status === 200) {
          this.props.onSnackbarMessage(`Successfully deleted #${this.state.resource.id}`)
          browserHistory.push(this.props.successRedirectPath)
        } else if (res.status === 400) {
          this.setState({ showDelete: false })
          res.json().then(({ message }) => {
            if (message) {
              this.setState({ message })
            }
          })
        }
      })
      .catch(() => {
        this.setState({ showDelete: false })
      })
  }

  handleMoreMenuOpen (e) {
    e.preventDefault()

    this.setState({
      moreMenuOpen: true,
      moreAnchorEl: e.currentTarget
    })
  }

  handleMoreMenuClose () {
    this.setState({
      moreMenuOpen: false
    })
  }

  handleMoreMenuItemTouchTap (e, obj) {
    if (obj.props.value) {
      browserHistory.push(obj.props.value)
    }
  }

  handleAcknowledgeErrorMessage () {
    this.setState({ message: null })
  }

  render () {
    const formStyle = {
      maxWidth: 500
    }

    const buttonStyle = {
      margin: '1em 1em 0 0'
    }

    const deleteActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleDeleteClose.bind(this)}
      />,
      <FlatButton
        label='Delete'
        primary
        keyboardFocused
        onClick={this.handleDeleteConfirm.bind(this)}
      />
    ]

    const undeleteActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleUndeleteClose.bind(this)}
      />,
      <FlatButton
        label='Restore'
        primary
        keyboardFocused
        onClick={this.handleUndeleteConfirm.bind(this)}
      />
    ]

    return (
      <div>
        <Actions
          resource={this.state.resource}
          successRedirectPath={this.props.successRedirectPath}
          buildMenuItems={this.props.buildMenuItems}
          handleMoreMenuOpen={this.handleMoreMenuOpen.bind(this)}
          handleMoreMenuClose={this.handleMoreMenuClose.bind(this)}
          handleMoreMenuItemTouchTap={this.handleMoreMenuItemTouchTap.bind(this)}
          moreMenuOpen={this.state.moreMenuOpen}
          moreAnchorEl={this.state.moreAnchorEl}
        />
        <form onSubmit={this.handleSubmit.bind(this)} style={formStyle}>
          <CardTitle title={`${this.props.title} #${this.state.resource.id}`} style={{ paddingLeft: 0 }} />

          <FieldList
            fields={this.props.fields}
            autocompleteText={this.state.autocompleteText}
            autocompleteResults={this.state.autocompleteResults}
            handleAutocompleteSelection={this.handleAutocompleteSelection.bind(this)}
            handleAutocompleteUpdateInput={this.handleAutocompleteUpdateInput.bind(this)}
            handleAutocompleteFocus={() => true}
            handleChipInputAdd={this.handleChipInputAdd.bind(this)}
            handleChipInputDelete={this.handleChipInputDelete.bind(this)}
            resource={this.state.resource}
            resourceFiles={this.state.resourceFiles}
            errors={this.state.errors}
            onChange={this.handleValueChange.bind(this)}
            handleFileChange={this.handleFileChange.bind(this)}
          />

          <RaisedButton
            label='Update'
            primary
            onClick={this.handleSubmit.bind(this)}
            style={buttonStyle}
            labelPosition='before'
            icon={this.state.submitting ? <CircularProgress size={20} thickness={2} /> : null}
            disabled={this.state.submitting}
          />
          <RaisedButton
            label='Cancel'
            onClick={this.handleCancel.bind(this)}
            style={buttonStyle}
          />
          {this.state.resource.deleted_at && !this.props.disableDelete &&
            <FlatButton
              label='Undelete'
              secondary
              onClick={this.handleUndeleteOpen.bind(this)}
              icon={<DeleteIcon />}
              style={buttonStyle}
            />}
          {!this.state.resource.deleted_at && !this.props.disableDelete &&
            <p style={{ padding: '20px 0' }}>Want to remove the whole reservation?
              <Link onClick={this.handleDeleteOpen.bind(this)}>
                <span style={{ color: '#0117DE', textDecoration: 'underline', paddingLeft: '5px', cursor: 'pointer' }}>Delete reservation.</span>
              </Link>
            </p>}
        </form>

        <Dialog
          title='Confirm delete'
          actions={deleteActions}
          modal={false}
          open={this.state.showDelete}
          onRequestClose={this.handleDeleteClose.bind(this)}
        >
          Are you sure you want to delete this record?
        </Dialog>

        <Dialog
          title='Confirm undelete'
          actions={undeleteActions}
          modal={false}
          open={this.state.showUndelete}
          onRequestClose={this.handleUndeleteClose.bind(this)}
        >
          Are you sure you want to restore this deleted record?
        </Dialog>

        <Dialog
          title='Error'
          modal={false}
          open={!!this.state.message}
          actions={[
            <FlatButton
              label='OK'
              primary
              onClick={this.handleAcknowledgeErrorMessage.bind(this)}
            />
          ]}
          onRequestClose={this.handleAcknowledgeErrorMessage.bind(this)}
        >
          {this.state.message}
        </Dialog>
      </div>
    )
  }
}

// @ts-ignore
Edit.propTypes = {
  apiPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ])).isRequired,
  successRedirectPath: PropTypes.string.isRequired,
  onSnackbarMessage: PropTypes.func.isRequired,
  disableDelete: PropTypes.bool,
  options: PropTypes.object,
  serializePatchBody: PropTypes.func,
  lastUpdatedAt: PropTypes.instanceOf(Date)
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  onSnackbarMessage: (msg) => {
    dispatch(setSnackbarMessage(msg))
  }
})

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(Edit)
